export default __webpack_public_path__ + "static/media/Attensie_Logo_Wit.f501dfd8.svg";